import fastdom from 'fastdom';
import load from '#core/load';
import util from '#core/util';
import events from '#core/events';


const button_v3_$ = '.button.\\:version-3';
const icon_$ = '.button__icon';
const scale_prop = '--button-icon-circle-hover-scale';
const overshoot = 8;


const module = {
	/**
	 * Init module
	 */
	init() {
		if (load.ran('button')) return false;

		load.content(() => {
			calculate_all();
		});
	},
};

export default module;
module.init();


/**
 * Query all v3 buttons and bind scale recalculation on resize and reinitialize
 */
function calculate_all() {
	const $buttons = document.querySelectorAll(button_v3_$);
	if (!$buttons.length) return;

	$buttons.forEach(calculate_scale);

	window.addEventListener('resize', util.debounce(() => {
		const $fresh = document.querySelectorAll(button_v3_$);
		$fresh.forEach(calculate_scale);
	}, 200));

	window.addEventListener(events.global.reinitialize, () => {
		const $fresh = document.querySelectorAll(button_v3_$);
		$fresh.forEach(calculate_scale);
	});
}


/**
 * Calculate and set the icon circle hover scale so the circle covers the button
 * @param {HTMLElement} $button
 */
function calculate_scale($button) {
	const $icon = $button.querySelector(icon_$);
	if (!$icon) return;

	fastdom.measure(() => {
		const button_width = $button.offsetWidth;
		const icon_width = $icon.offsetWidth;

		// Distance from icon center to the farthest button edge
		const icon_rect = $icon.getBoundingClientRect();
		const button_rect = $button.getBoundingClientRect();
		const icon_center_x = icon_rect.left + icon_rect.width / 2 - button_rect.left;
		const icon_center_y = icon_rect.top + icon_rect.height / 2 - button_rect.top;

		// Farthest corner distance (covers all icon positions)
		const max_x = Math.max(icon_center_x, button_width - icon_center_x);
		const max_y = Math.max(icon_center_y, $button.offsetHeight - icon_center_y);
		const radius = Math.sqrt(max_x * max_x + max_y * max_y);

		const scale = (radius + overshoot) / (icon_width / 2);

		fastdom.mutate(() => {
			$button.style.setProperty(scale_prop, scale.toFixed(2));
		});
	});
}
